<script>
import App from '@/pages/layouts/app';
import Menu from '@/pages/customers/_menu.vue';
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import Card from "@/pages/components/card.vue";

export default {
  components: {App, Menu, Card},
  props: ['customerId', 'tableConfig'],
  mixins: [Datatable]
}
</script>

<template>
  <App title="Geleverde onderdelen">
    <Menu :customer-id="customerId" />


    <Card>
      <Table ref="table" id="customer_parts" :config="tableConfig" />
    </Card>
  </App>
</template>